import { Box, CircularProgress, Container, Grid, Pagination, Switch, Typography, Button, Drawer, FormGroup, FormControlLabel, Checkbox, Slider, Tabs, Tab, Skeleton, Avatar } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Gallery_BASE_URL } from '../../config';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import { fetchCategoryById } from '../../reduxState/categorySlice/categoryGetbyidSlice';
import { AppDispatch, RootState } from '../../reduxState/store';
import ProductMerchantListTab from './categoryMerchantListTab';
import categoryEmpty from '../../assets/images/categoryEmpty.webp'
import { fetchBranchs } from '../../reduxState/branchSlice/branchGetallslice';
import GoToTop from '../commonToast/ontopScroll';

type Anchor = 'right';

const sortBy = [
  { 'Value': 'Recommended' },
  { 'Value': 'Popularly' },
  { 'Value': 'Rating' },
  { 'Value': 'Discount' }
]

const distanceButton = [
  { 'Value': 'LessThan30Mins', 'text': 'Less than 30 Mins' },
  { 'Value': 'LessThan45Mins', 'text': 'Less than 45 Mins' },
]

const vegList = [
  { 'Value': 'Veg', 'text': 'Veg' },
  { 'Value': 'Both', 'text': 'Both' },
]

const BranchList: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const category = useSelector((state: RootState) => state.categoryById);
  const branch = useSelector((state: RootState) => state.branchList);
  const [page, setPage] = React.useState(1);
  const [isveg, setIsveg] = React.useState(false);
  const limit = 20;
  const [state, setState] = React.useState({
    right: false,
  });
  const [range, setRange] = React.useState<any>(['10', '300']);
  const cuisineType = useSelector((state: RootState) => state.categoryTypeList);
  const [selectedSortby, setSelectedSortby] = React.useState<any>('');
  const [selectedCuisineIds, setSelectedCuisineIds] = React.useState<any>('');
  const [selectedCuisineName, setSelectedCuisineNames] = React.useState<any>('');
  const [distance, setDistance] = React.useState<any>(distanceButton[0].Value);
  const [veg, setVeg] = React.useState<any>(vegList[0].Value);
  const [textValue, setTextValue] = React.useState<any>('');

  // filter isVeg 
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  React.useEffect(() => {
    if (textValue) {
      if (veg === 'Veg') {
        setIsveg(true)
      } else {
        setIsveg(false)
      }
    }
  }, [veg, textValue])

  // filter distance details
  const [valueDistance, setValueDistance] = React.useState(0);

  const handleChangeDistance = (event: React.SyntheticEvent, newValue: number) => {
    setValueDistance(newValue);
  };

  function a11yPropsDistance(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // getbyid category
  React.useEffect(() => {
    dispatch(fetchCategoryById(location.state));
  }, [location.state]);

  // category based merchant
  React.useEffect(() => {
    dispatch(fetchBranchs({ categoryId: location.state, status: 'ACTIVE', pageNo: page, size: limit, isVeg: isveg ? 'Veg' : 'Both' }))
  }, [location.state, page, isveg])

  //pagination event
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const toggleDrawer = (anchor: Anchor, open: boolean, text?: any) => (
    event: React.KeyboardEvent | React.MouseEvent) => {
    setTextValue('')
    if (text) {
      setTextValue(text)
      dispatch(fetchBranchs({ categoryId: location.state, priceRange: range[0] + '-' + range[1], isVeg: veg, deliveryTime: distance, sortBy: selectedSortby, restaurantType: selectedCuisineIds }))
    }
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleChanges = (event: any, newValue: any) => {
    setRange(newValue);
  }

  const handleCheckBoxSortby = (value: any) => (event: any) => {
    const selectedValue = value.Value;
    if (event.target.checked) {
      setSelectedSortby((prevArray: any) => [...prevArray, selectedValue]);
    } else {
      setSelectedSortby((prevArray: any) => prevArray.filter((id: any) => id !== selectedValue));
    }
  };

  const handleCheckBoxChange = (cuisine: any) => (event: any) => {
    const selectedId = cuisine.id;
    const selectedName = cuisine.name;
    if (event.target.checked) {
      setSelectedCuisineIds((prevArray: any) => [...prevArray, selectedId]);
      setSelectedCuisineNames((prevArray: any) => [...prevArray, selectedName]);
    } else {
      setSelectedCuisineIds((prevArray: any) => prevArray.filter((id: any) => id !== selectedId));
      setSelectedCuisineNames((prevArray: any) => prevArray.filter((name: any) => name !== selectedName));
    }
  };

  const list = (right: Anchor) => (
    <Box
      className="toggle-width"
      role="presentation"
    >
      <Typography textAlign={'center'} mt={2} className='reem-kulfi drawer-head'>Filters</Typography>
      <Box px={4}>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>Sort By</Typography>
        <hr />
        <FormGroup sx={{ px: 2 }}>
          {sortBy.map((value: any, index: any) => (
            <FormControlLabel
              key={index}
              className='slider-checkBox'
              control={
                <Checkbox
                  onChange={handleCheckBoxSortby(value)}
                  checked={selectedSortby.includes(value?.Value)}
                  color="warning"
                />
              }
              label={value.Value}
            />
          ))}
        </FormGroup>
      </Box>
      <Box px={4}>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>Restaurant</Typography>
        <hr />
        <FormGroup sx={{ px: 2 }}>
          {cuisineType.data.map((cuisine: any, index: any) => (
            <FormControlLabel
              key={index}
              className='slider-checkBox'
              control={
                <Checkbox
                  onChange={handleCheckBoxChange(cuisine)}
                  checked={selectedCuisineIds.includes(cuisine?.id)}
                  color="warning"
                />
              }
              label={cuisine.name}
            />
          ))}
        </FormGroup>
      </Box>
      <Box px={4}>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>Recipe Type</Typography>
        <Box display={'flex'} py={2}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            className='reem-kulfi filter-select'
            aria-label="scrollable auto tabs example">
            {vegList?.map((value, index) => (
              <Tab key={index} label={value.text} sx={{ mr: 3 }} {...a11yProps(index)} onClick={() => { setVeg(value.Value) }} className='filter-select-button' />
            ))}
          </Tabs>
        </Box>
      </Box>
      <Box px={4}>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>Delivery Time</Typography>
        <Box display={'flex'} py={2}>
          <Tabs
            value={valueDistance}
            onChange={handleChangeDistance}
            variant="scrollable"
            scrollButtons="auto"
            className='reem-kulfi filter-select'
            aria-label="scrollable auto tabs example">
            {distanceButton?.map((value, index) => (
              <Tab key={index} label={value.text} sx={{ mr: 3 }} {...a11yPropsDistance(index)} onClick={() => { setDistance(value.Value) }} className='filter-select-button' />
            ))}
          </Tabs>
        </Box>
      </Box>
      <Box px={4} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>Price Range</Typography>
        <Typography mt={2} className='reem-kulfi drawer-sub-head'>{range[0]} - {range[1]}</Typography>
      </Box>
      <Box px={4}>
        <Slider value={range} onChange={handleChanges} valueLabelDisplay="auto" max={1000} sx={{ py: 5, color: '#FB640A' }} />
      </Box>
      <Box padding={'104px'} py={5} textAlign={'center'}>
        <Button variant='contained' className='reem-kulfi filter-select-submit' sx={{ width: '100%' }} onClick={toggleDrawer('right', false, 'close')}>Submit</Button>
      </Box>
    </Box>
  )

  return (
    <React.Fragment>
      {/* {category?.code === 200 && category?.loading === false ? */}
      <Box className='bg-head'>
        <Container fixed>
          <Grid container pb={5} pt={2} justifyContent={'space-between'}>
            <Grid item xs={12} display='flex'>
              {category?.loading ?
                <Skeleton variant="circular">
                  <Avatar sx={{width:'100px', height:'100px'}}/>
                </Skeleton> :
                <>
                  {category?.data?.images.filePath === null ?
                    <img src={categoryEmpty} alt="Merchant Image" width='100px' height='100px' style={{ borderRadius: '50%', objectFit: 'cover' }} loading='lazy' /> :
                    <img src={`${Gallery_BASE_URL}${category?.data?.images?.filePath}`} alt="Merchant Image" width='100px' height='100px' style={{ borderRadius: '50%', objectFit: 'cover' }} loading='lazy' />
                  }
                </>}
              <Box p={2} py={2.5} width={'50%'}>
                {category?.loading ?
                  <Skeleton width={'75%'}>
                    <Typography mt={1} className='product-list-head inter-med'>.</Typography>
                  </Skeleton> :
                  <Typography mt={1} className='product-list-head inter-med'>{category?.data?.categoryName}</Typography>}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* :
                <Box className='loader'><CircularProgress sx={{ color: '#FB640A' }} /></Box>
            } */}
      <Box>
        <Container fixed>
          <Grid container pb={5} pt={2} justifyContent={'space-between'} alignItems={'center'}>
            <Grid item lg={6} sm={8.25} pb={5}>
              <Typography className='merchant-list-head reem-kulfi'>All Restaurants Delivering {category?.data?.categoryName}</Typography>
            </Grid>
            <Grid item lg={4.5} sm={2.5} pb={5}>
              <Switch color="warning" checked={isveg} onChange={(newValue: any) => setIsveg(newValue.target.checked)} />
              <span className='vegOnly roboto-med'>Veg only</span>
            </Grid>
            <Grid item lg={1.5} sm={0.75} pb={5} display={'flex'} justifyContent={'end'} alignItems={'center'}>
              <Button variant='outlined' className='filter-button' onClick={toggleDrawer("right", true)}>
                <FilterListOutlinedIcon fontSize='medium' />
              </Button>
              <Drawer
                anchor={'right'}
                open={state['right']}
                onClose={toggleDrawer('right', false)}
              >
                {list('right')}
              </Drawer>
            </Grid>
            <Grid item xs={12}>
              <ProductMerchantListTab page={page} limit={limit} isVeg={isveg} submit={textValue} cuisineName={selectedCuisineName} />
            </Grid>
            <Grid item xs={12} display={'flex'} justifyContent={'end'}>
              <Pagination page={page} count={Math.ceil(branch?.size / limit)} size="small" onChange={handleChangePage} showFirstButton showLastButton defaultPage={1} siblingCount={0} boundaryCount={1}
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#000',
                    background: '#FFFFFF',
                    border: '0.742647px solid #DFE3E8',
                    borderRadius: '2.97059px',
                    margin: '0 2px',
                    '&.Mui-selected': {
                      backgroundColor: '#FFFFFF',
                      color: '#FC8019',
                      border: '0.742647px solid #FC8019',
                    },
                  },
                }}
              />
            </Grid>
          </Grid>
          <GoToTop />
        </Container>
      </Box>
    </React.Fragment>
  )
}

export default BranchList